/**
 * @file: MaintenancePlanUpdatedBody.tsx
 *
 * `OrgMaintenancePlanUpdated` — a new maintenance-plan detail was
 * added under an order. Title quotes the subject name; the abnormal-
 * level chip sits inline; the supplementary date/mileage/remark rows
 * come from the shared `PlanDetailCard`.
 */

import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { OrgMaintenancePlanUpdatedFeedPayload } from '@euler/model/feed';
import { FC } from 'react';
import { View } from 'react-native';
import { PlanDetailCard } from './common/PlanDetailCard';
import { PlanDetailReasonSignature } from './common/PlanDetailReasonSignature';
import { abnormalLevelInfo, detailTypeName } from './common/labels';
import { Chip, TitleText } from './common/primitives';

export const MaintenancePlanUpdatedBody: FC<{
  p: OrgMaintenancePlanUpdatedFeedPayload;
}> = ({ p }) => {
  const { rpx } = useResponsiveContext();
  const subjectName = p.planDetail.customAlertSubjectName ?? p.planDetail.name;
  const ab = abnormalLevelInfo(p.planDetail.abnormalLevel);
  return (
    <View>
      <View
        css={`
          flex-direction: row;
          align-items: center;
          flex-wrap: wrap;
        `}
      >
        <TitleText>新增维保项「{subjectName}」</TitleText>
        <View style={{ marginLeft: rpx(8) }}>
          <Chip text={detailTypeName(p.planDetail.type)} color="#6b7280" />
        </View>
        <View style={{ marginLeft: rpx(6) }}>
          <Chip text={ab.name} color={ab.color} />
        </View>
      </View>
      <PlanDetailCard detail={p.planDetail} />
      <PlanDetailReasonSignature
        type={p.planDetail.type}
        unsolvedReason={p.planDetail.unsolvedReason}
        signatureImgUrl={p.planDetail.customerSignatureImgUrl}
      />
    </View>
  );
};
